"use client";

import Typography from "@/ui/atoms/Typography"
import Container from "@/ui/structure/Container"

const NotFoundContainer = () => {
  return (
    <Container className="py-16">
      <Typography variant={"h3"} textAlign={"center"}>
        Page not found
      </Typography>
      <img
        className="mx-auto"
        src={
          "https://cdn.sanity.io/images/atgipfvs/production/635d09b413759133e318e2c5b71f2c66cb19c974-450x450.png"
        }
      />
    </Container>
  )
}

export default NotFoundContainer
